module.exports = __webpack_public_path__ + "static/eastwood-success-099cf28135609e20fd0311c631d0433d.svg";